<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="records && records.length">
    <h4 (click)="toggleCollapse()"
        class="recently-viewed-header mt-0 pb-1 pl-2 pr-2">
        <scrm-label labelKey="LBL_LAST_VIEWED"></scrm-label>
    </h4>
    <ng-container *ngIf="!collapsed">
        <div (click)="onClick && onClick()"
             *ngFor="let recentRecord of records | slice:0:maxDisplayed"
             class="nav-item"
        >
            <a [routerLink]="this.buildRoute(recentRecord)"
               class="nav-link action-link pb-2 pt-2">
                {{ recentRecord.attributes.item_summary }}
            </a>
        </div>
    </ng-container>
</ng-container>
